const makeUserProgressEventData = data => ({
  assetId: data.assetId,
  type: data.type,
  userProgress: data.userProgress,
  current: data.current,
  total: data.total
});

export { makeUserProgressEventData };
